var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgChevronIconinline = function SvgChevronIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.6 26.954a1.267 1.267 0 010-1.825L12.024 14 .601 2.869a1.267 1.267 0 010-1.826 1.349 1.349 0 011.872 0L15.768 14 2.473 26.954a1.349 1.349 0 01-1.872 0z"
  })));
};
export default SvgChevronIconinline;